import { getTimezoneOffset } from 'date-fns-tz';

const getTimeZoneOffsetInMin = (timeZone: string, date: Date) => {
  const offset = getTimezoneOffset(timeZone, date);

  const oneMinInMillisec = 60000;
  return offset / oneMinInMillisec;
};

window.getTimeZoneOffsetInMin = getTimeZoneOffsetInMin;

export default getTimeZoneOffsetInMin;
